import React from 'react';

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export default function ImportResultsDialog(props) {

	const { label, logs, closeCallback } = props;
	const title = label + ' Import Logs';
	
	const getLines = () => {
		let results = [];
		for (let i = 0; i < logs.length; i++) {
			results.push(
				<div tabIndex={0} key={i}className="constituo-console-log">
					{logs[i]}
				</div>
			);
		}
		return results;
	};

	return (
		<Dialog title={title} onClose={closeCallback}>
	    	<div
	        	style={{
	            	margin: "0px",
	            	width: "400px",
	            	height: "300px",
	              	overflow: "auto"
	            }}
			>
				{getLines()}
			</div>
	        <DialogActionsBar>
        		<button
            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              		onClick={closeCallback}
            	>
            		Close
            	</button>
	        </DialogActionsBar>
		</Dialog>
	);
}